export const FILE_VALIDATION_CONSTANTS = {
  MAX_SIZE_MB: 10,
  MAX_FILES_DEFAULT: 10,
  VALID_EXTENSIONS: ['PDF', 'JPG', 'JPEG', 'PNG'],
  DEFAULT_MAX_SIZE: '10MB',
  MAX_ALIAS_FILE_NAME_LENGTH: 250,
  BYTES_PER_MB: 1024 * 1024,
  UNKNOWN_FILE_NAME: 'Archivo desconocido',
} as const;

export const FILE_VALIDATION_MESSAGES = {
  SIZE_EXCEEDED: (fileName: string, sizeMB: string, maxSize: string) =>
    `El archivo "${fileName}" (${sizeMB}MB) excede el tamaño máximo de ${maxSize}.`,
  INVALID_TYPE: (fileName: string, validTypes: string) =>
    `El archivo "${fileName}" tiene un formato no permitido. Solo se aceptan: ${validTypes}.`,
  MAX_FILES: (maxFiles: number, attempted: number) =>
    `Solo puedes subir un máximo de ${maxFiles} ${maxFiles === 1 ? 'archivo' : 'archivos'}. Intentaste agregar ${attempted}.`,
  MAX_FILES_SIMPLE: (maxFiles: number) =>
    `Máximo ${maxFiles} ${maxFiles === 1 ? 'archivo permitido' : 'archivos permitidos'}.`,
  GENERIC: 'Error de validación de archivo.',
} as const;

export const EMPTY_FILE_MESSAGE_SINGULAR =
  'El archivo está vacío (0 bytes). Vuelve a descargarlo y súbelo de nuevo.';

export const EMPTY_FILE_MESSAGE_PLURAL =
  'Hay archivos vacíos (0 bytes). Revísalos y vuelve a subirlos.';

export const EMPTY_FILE_ITEM_MESSAGE = 'Archivo vacío (0 bytes)';
